"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractData = exports.cirrusStoreCacheKey = exports.useCirrusStoreGet = void 0;
const react_cirrus_1 = require("@yanzi/react-cirrus");
const socket_1 = require("@yanzi/socket");
const react_1 = require("react");
const react_query_1 = require("react-query");
function useCirrusStoreGet(url, contentType = 'application/json', { skip = false } = {}) {
    react_1.useEffect(() => {
        if (!url.match(/^yanzi:\/\//)) {
            throw new Error('Invalid URL given to useCirrusStoreGet');
        }
    }, [url]);
    const { socket } = react_cirrus_1.useCirrus();
    const res = react_query_1.useQuery(cirrusStoreCacheKey(socket, url, contentType), () => {
        return socket
            .storeGetRequest({ messageType: 'StoreGetRequest', url })
            .next()
            .then(({ value }) => extractData(value, contentType));
    }, {
        cacheTime: 30 * 60 * 1000,
        staleTime: 30 * 60 * 1000,
        enabled: !skip,
        retry: false,
    });
    return react_1.useMemo(() => {
        var _a, _b;
        return (Object.assign(Object.assign({}, res), { data: (_a = res.data) !== null && _a !== void 0 ? _a : null, error: ((_b = res.error) !== null && _b !== void 0 ? _b : null), loading: res.isLoading }));
    }, [res]);
}
exports.useCirrusStoreGet = useCirrusStoreGet;
function cirrusStoreCacheKey(socket, url, contentType) {
    return ['cirrus-store', serializeSocket(socket), url, ...(contentType ? [contentType] : [])];
}
exports.cirrusStoreCacheKey = cirrusStoreCacheKey;
function extractData(data, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (contentType) {
            case 'application/json':
                const str = socket_1.bufferToString(data);
                try {
                    return JSON.parse(str);
                }
                catch (e) {
                    console.error('Error parsing JSON. Input string: ', str, 'Error:', e);
                    return null;
                }
            case 'raw':
                return data;
            default:
                throw new Error('Invalid content type');
        }
    });
}
exports.extractData = extractData;
function serializeSocket(socket) {
    return `YanziSocket-${socket.id}`;
}
//# sourceMappingURL=useCirrusStoreGet.js.map